import React from "react";

export const GaFooter: React.FC = () => {
    return (
        <footer className="bg-gray-900 text-gray-400 py-4 mt-auto">
            <div className="container mx-auto text-center">
                <small>
                    &copy; {new Date().getFullYear()} - Prefeitura Municipal de
                    Araucária
                </small>
            </div>
        </footer>
    );
};
